"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemPropertyHandlerContent = void 0;
/**
 * Handler for an item property with the 'content' attribute.
 */
class ItemPropertyHandlerContent {
    canHandle(tagName, attributes) {
        return 'content' in attributes;
    }
    getObject(attributes, util, itemScope) {
        return util.createLiteral(attributes.content, itemScope);
    }
}
exports.ItemPropertyHandlerContent = ItemPropertyHandlerContent;
//# sourceMappingURL=ItemPropertyHandlerContent.js.map